const dollarUSLocale = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});
export const formatToUSD = (number: number) => {
  const dollar = Math.round(number) / 100;
  return dollarUSLocale.format(dollar);
};
